module.exports = __webpack_public_path__ + "static/startup3-49f35592969df61ec34ccce0eb00fed7.png";